module.exports = __webpack_public_path__ + "media/components/src/assets/images/icons/icon-baby-770a42bb66760574181d9942006b96dc.png";